import React from 'preact/compat';

export default function SingleResult(props) {
    const { url, title, treePath } = props;
    return (
        <li className="single-result">
            <a href={url}>
                <strong>{title}</strong>
                <ul className="single-result-breadcrumbs">
                    {treePath.slice(1, -1).map((obj) => (
                        <li>
                            { obj.title }
                        </li>
                    ))}
                </ul>
            </a>
        </li>
    );
}
